
    <p mat-dialog-content>
      Your appointment will not be created without a deposit. Are you sure you
      want to cancel?
    </p>

    <div mat-dialog-actions>
      <button mat-button (click)="close()">No</button>

      <button mat-button (click)="cancelRequest()">Cancel Request</button>
    </div>
  